import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import InputField from '../../components/InputField';
import { BASVURU_HARCI, VEKALET_SURET_HARCI, VEKALET_PULU } from '../../constants/constants';
import TebligatDropdown from '../../components/TebligatDropdown';
import Header from '../../components/Header';

const faqs = [
    {
        question: "Türk Borçlar Kanunu'nun 6098 sayılı maddesine göre kiracıların tahliyesini gerektiren çeşitli sebepler mevcuttur. Bunlardan biri de kiracının yazılı tahliye taahhüdü vermesidir.",
    },
    {
        question: "<h5>Kanun Maddesi:</h5>",
        answer: ["Türk Borçlar Kanunu'nun 352/1. maddesine göre:<p>\"Kiracı, kiralananın teslim edilmesinden sonra, kiraya verene karşı, kiralananı belli bir tarihte boşaltmayı yazılı olarak üstendiği halde boşaltmamışsa kiraya veren, kira sözleşmesini bu tarihten başlayarak bir ay içinde icraya başvurmak veya dava açmak suretiyle sona erdirebilir.\"</p>"],
    },
    {
        question: "<h5>Tahliye Taahhüdünün Şartları:</h5><p>Bu maddeye dayanarak kiracıyı tahliye edebilmek için tahliye taahhüdünün bazı şartları taşıması gerekir:</p>",
        answer: [
            "<strong>Yazılı Olmalıdır:</strong> Tahliye taahhüdü yazılı olarak yapılmalıdır. Adi yazılı şekil yeterlidir, resmi belge olması şart değildir.",
            "<strong>Yetkili Kişi Tarafından Verilmelidir:</strong> Taahhüt, kiracı veya yetkili temsilcisi tarafından verilmelidir. Birden fazla kiracı varsa tüm kiracılar taahhütnamede imza sahibi olmalıdır.",
            "<strong>Tahliye Tarihi Belirtilmelidir:</strong> Taahhütnamede kesin bir tahliye tarihi belirtilmelidir. Yalnızca ay olarak belirtilmesi geçersizliğe yol açar.",
            "<strong>Sözleşmeden Sonra Verilmelidir:</strong> Taahhüt, kira sözleşmesi ve taşınmazın tesliminden sonra verilmelidir.",
        ]
    },
    {
        question: "<h5>Tahliye İşlemi:</h5>",
        answer: [
            "Yukarıdaki şartları taşıyan bir taahhütnameye rağmen kiracı taşınmazı boşaltmazsa kiraya veren aşağıdaki yollardan birini seçebilir:"
        ]
    },
    {
        question: "<h5>1. İcra Takibi:</h5>",
        answer: [
            "Taahhüt edilen tarihten itibaren 1 ay içinde icra takibi başlatılabilir.",
            "İcra dairesi kiracıya 15 gün içinde tahliye ve teslim emri gönderir.",
            "Kiracı 7 gün içinde itiraz edebilir.",
            "İtirazın kaldırılması veya yapılmaması halinde taşınmaz zorla tahliye edilir.",
        ]
    },
    {
        question: "<h5>2. Tahliye Davası:</h5>",
        answer: [
            "Taahhüt edilen tarihten itibaren 1 ay içinde sulh hukuk mahkemesinde tahliye davası açılabilir.",
        ]
    },
    {
        question: "<h5>Dikkat Edilmesi Gerekenler:</h5>",
        answer: [
            "Tahliye hakkı kiraya verene aittir. Yargıtay kararlarına göre kiraya veren sıfatına sahip olmayan malik tarafından da talep edilebilir.",
            "1 aylık sürede icra takibi veya dava açılmazsa tahliye taahhüdü geçersiz hale gelir.",
        ]
    },
];

const TahliyeTaahhutnamesiHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

    const [tebligatValue, setTebligatValue] = useState(null);
	const [borcluSayisi, setBorcluSayisi] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}
            setTebligatValue(Number(decodeURIComponent(atob(query.get('tebligatValue')))));
            setBorcluSayisi(Number(decodeURIComponent(atob(query.get('borcluSayisi')))));
			setCalculated(true);
		}

		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
        if(tebligatValue && borcluSayisi) {
            let newResults = [
                { text: "Başvuru Harcı", value: BASVURU_HARCI },
                { text: "Vekalet Suret Harcı", value: VEKALET_SURET_HARCI },
                { text: "Vekalet Pulu", value: VEKALET_PULU },
                { text: "Tebligat Gideri", value: tebligatValue * borcluSayisi },
                { text: "Toplam İcra Masrafı", value: tebligatValue * borcluSayisi + VEKALET_PULU + VEKALET_SURET_HARCI + BASVURU_HARCI }
            ];

            setHideAll(true);
    
            const params = new URLSearchParams({
                results: btoa(encodeURIComponent(JSON.stringify(newResults))),
                borcluSayisi: btoa(encodeURIComponent(borcluSayisi.toString())),
                tebligatValue: btoa(encodeURIComponent(tebligatValue.toString())),
            });
    
            navigate(`${window.location.pathname}?${params.toString()}`);
            navigate(0);
        } else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>Tahliye Tahhütnamesine Dayalı İcra Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Tahliye taahhütnamesine dayalı icra takibi, kiracının kiralanan taşınmazı tahliye etme taahhüdüne uymaması durumunda, kiraya verenin icra mahkemesine başvurarak kiracının tahliyesini talep etme sürecidir." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>Tahliye Tahhütnamesine Dayalı İcra Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">Tahliye Tahhütnamesine Dayalı İcra Hesapla</h1>
                    <p>Tahliye taahhütnamesine dayalı icra takibi, kiracının kiralanan taşınmazı tahliye etme taahhüdüne uymaması durumunda, kiraya verenin icra mahkemesine başvurarak kiracının tahliyesini talep etme sürecidir.</p>
                    
                    <TebligatDropdown value={tebligatValue} setValue={setTebligatValue} />
                    <InputField value={borcluSayisi} setValue={setBorcluSayisi} trailText="kişi" label="Borçlu Sayısı" type="number" />
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>

            <Footer faqs={faqs} faqTitle="Tahliye Taahhütnamesine Dayalı İcra Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(TahliyeTaahhutnamesiHesaplama);
